// import React from 'react';
// import "./Events.css";
// import tedxvssut from "../Events/Events/tedxvssut.svg";
// import innobuzz from "../Events/Events/innobuzz.png";
// import esummit from "../Events/Events/esummit.png";
// import iplauction from "../Events/Events/iplauction.jpg";
// import leadershipsummit from "../Events/Events/leadershipsummit.png";
// const Events = () => {
//   return (
//     <>
//       <section id="events">
//         <header className="p-5">
//             <h3 className="text-center" data-aos="fade-up">Events</h3>
//         </header>
//         <div className="container-events d-flex justify-content-center align-items-center">
//             <div className="event-card center" data-aos="fade-up">
//                 <img className="eve-logo px-3" src={tedxvssut} alt=""/>
//                 <div className="event-slider centerY">
//                     <p>Tedx is a program of local, self organized events that brings in live speakers to combine and indulge in discussions.<br/>TEDx VSSUT is organized annually inviting speakers from distinguished fields who share their experiences and inspire
//                         all.
//                     </p>
//                 </div>
//             </div>
//             <div className="event-card center" data-aos="fade-up">
//                 <img className="eve-logo px-3" src={innobuzz} alt=""/>
//                 <div className="event-slider centerY">
//                     <p>A 36-hour national level hackathon where participants get a chance to win exciting goodies and cash prizes by submitting effective solutions to a problem statement.</p>
//                 </div>
//             </div>
//             <div className="event-card center" data-aos="fade-up">
//                 <img className="eve-logo px-3" src={esummit} alt=""/>
//                 <div className="event-slider centerY">
//                     <p>Eastern India's biggest flagship event brings together a horde of business moghuls and industry experts to butt heads for the much needed societal changes.</p>
//                 </div>
//             </div>
//             <div className="event-card center" data-aos="fade-up">
//                 <img className="eve-logo px-3" src={iplauction} alt=""/>
//                 <div className="event-slider centerY">
//                     <p>A fun event where participants place themselves in the shoes of a bidder to build a dream team they always thought of. Team with the best bargaining and bidding skills wins.</p>
//                 </div>
//             </div>
//             <div className="event-card center" data-aos="fade-up">
//                 <img className="eve-logo px-3" src={leadershipsummit} alt=""/>
//                 <div className="event-slider centerY">
//                     <p>An exciting opportunity for youngsters to learn from influential leaders and engage themselves in various skill-based events.</p>
//                 </div>
//             </div>
//           </div>
//           </section>
//        </>
//  )
// }

// export default Events
import React from 'react'

const Events = () => {
  return (
    <div>
      Events
    </div>
  )
}

export default Events
